
export function initAniOverlay() {
  document.querySelectorAll('.ani-overlay-on-inview').forEach(el => {
    if (el.querySelector('.ani-overlay-layer')) return; 
    const layer = document.createElement('div');
    layer.className = 'ani-overlay-layer';
    el.appendChild(layer);
  });
}
